import React, { useContext, useEffect, useState } from 'react';
import LinkWithIcon from '@legacy-vfuk/core-link-with-icon';
import { LinkWithIconWrapper } from './styles/StyledLinkWithIcon.styles';;
import { DirectionContext } from '../../../../contexts/DirectionContext';
import fireButtonAndLinkClicksEvent from '../../../../helpers/fireButtonAndLinkClicksEvent';
import { addHashIfMissing } from '../../../../helpers/navigationHelpers';

const MOBILE_VIEW_WIDTH = 638;

interface StyledLinkWithIconProps {
  desktop: {
    label: string;
    appearance: 'primary' | 'secondary' | 'alt1';
    inverse: boolean;
    underline: boolean;
  };
  mobile: {
    label: string;
    appearance: 'primary' | 'secondary' | 'alt1';
    inverse: boolean;
    underline: boolean;
  };
  iconName: string;
  targetSectionId: string;
}

const StyledLinkWithIcon = ({
  desktop,
  mobile,
  iconName,
  targetSectionId
}: StyledLinkWithIconProps) => {
  const isMobile = checkWindowSize();

  function checkWindowSize() {
    const [isMobile, setIsMobile] = useState(false);
    if (typeof window !== 'undefined') {
      useEffect(() => {
        function handleResize() {
          if (window.innerWidth <= MOBILE_VIEW_WIDTH) {
            setIsMobile(true);
          }
        }
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
      }, []);
    }
    return isMobile;
  }

  function handleClick(label: string) {
    fireButtonAndLinkClicksEvent({ event_label: label, event_action: "button click" });
  }

  const direction = useContext(DirectionContext);

  return (
    <LinkWithIconWrapper
      isMobile={isMobile}
      desktopApperance={desktop.appearance}
      mobileAppearance={mobile.appearance}
      desktopUnderline={desktop.underline}
      mobileUnderline={mobile.underline}
      isRtl={direction === 'rtl'}
    >
      <LinkWithIcon
        appearance={(isMobile ? mobile.appearance : desktop.appearance) || undefined}
        inverse={isMobile ? mobile.inverse : desktop.inverse}
        text={(isMobile && mobile.label) ? mobile.label : desktop.label}
        icon={{
          name: iconName
        }}
        href={addHashIfMissing(targetSectionId)}
        onClick={() => handleClick(isMobile ? mobile.label : desktop.label)}
      />
    </LinkWithIconWrapper>
  );
};

export default StyledLinkWithIcon;
